import { render, staticRenderFns } from "./carousal-component.vue?vue&type=template&id=45199b03&scoped=true&"
import script from "./carousal-component.vue?vue&type=script&lang=js&"
export * from "./carousal-component.vue?vue&type=script&lang=js&"
import style0 from "./carousal-component.vue?vue&type=style&index=0&id=45199b03&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45199b03",
  null
  
)

component.options.__file = "carousal-component.vue"
export default component.exports